export default function getMessageFromApiResponse(apiResponse) {
  if (!apiResponse) throw new Error('Missing api response')
  const { error, error_description, isLocked, remainingAttemptCount, lockedInMinutes } = apiResponse
  const isUnauthorized = error?.toLowerCase() === 'unauthorized'
  const isAccountLocked = isLocked?.toLowerCase() === 'true'
  if (isUnauthorized && Number(remainingAttemptCount) > 1) {
    return `Incorrect username or password entered. Please try again. You have ${remainingAttemptCount} attempts remaining.`
  } else if (isUnauthorized && Number(remainingAttemptCount) === 1) {
    return `Incorrect username or password entered. Please try again. You have 1 attempt remaining. If you're having trouble remembering your password, you can click "Forgot your password?" to reset it.`
  } else if (isAccountLocked) {
    return `Incorrect username or password entered. You have 0 attempts remaining. Your account has been locked for ${lockedInMinutes} mins. Please reset your password or try again later.`
  } else if (error_description?.toLowerCase()?.includes('locked')) {
    return 'Your account has not been verified. Please check your email and follow the instructions.'
  }
  return error_description
}
